import React, { useState } from 'react';
import { Button, Modal, Typography } from 'antd';
import { CopyOutlined, DeleteOutlined, DownOutlined, RightOutlined } from '@ant-design/icons';

const { Title } = Typography;

interface PartActionsProps {
    isVariation?: boolean;
    loading?: boolean;
    onDuplicate?: () => void;
    onRemove?: () => void;
    togglePartExpansion?: (e?: React.MouseEvent) => void;
    isExpanded?: boolean;
}

export function PartActions({
    isVariation = false,
    loading = false,
    onDuplicate,
    onRemove,
    togglePartExpansion,
    isExpanded,
}: PartActionsProps) {
    const handleClick = (e: React.MouseEvent<HTMLElement, MouseEvent>, action: (() => void) | undefined) => {
        e?.stopPropagation();
        action?.();
    };

    const handleRemove = () => {
        Modal.confirm({
            title: 'Remove Part',
            content: isVariation
                ? 'Are you sure you want to remove this variation?'
                : 'Are you sure you want to remove this part?',
            okText: 'Remove',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk: async () => {
                await Promise.resolve(onRemove?.());
            },
        });
    };

    return (
        <>
            <div className="flex flex-row gap-1">
                {!isVariation && (
                    <Button
                        size="small"
                        type="text"
                        onClick={e => handleClick(e, onDuplicate)}
                        icon={<CopyOutlined className="" />}
                        className="h-6 w-6 p-0"
                        title="Create a new variant of this part to try different materials, surface finishes, or coatings and compare pricing."
                        disabled={loading}
                    />
                )}

                <Button
                    size="small"
                    type="text"
                    onClick={handleRemove}
                    icon={<DeleteOutlined className="" />}
                    className="h-6 w-6 p-0  hover:text-red-700 hover:bg-red-50"
                    title="Remove"
                    disabled={loading}
                />

                {/* Expand/Collapse Button */}
                {/*<div className="flex items-center flex-shrink-0">*/}
                {/*    <Button*/}
                {/*        size="small"*/}
                {/*        type="text"*/}
                {/*        onClick={e => {*/}
                {/*            togglePartExpansion?.(e);*/}
                {/*        }}*/}
                {/*        icon={*/}
                {/*            isExpanded ? (*/}
                {/*                <DownOutlined*/}
                {/*                    className=""*/}
                {/*                    style={{*/}
                {/*                        fontSize: '18px',*/}
                {/*                    }}*/}
                {/*                />*/}
                {/*            ) : (*/}
                {/*                <RightOutlined*/}
                {/*                    className=""*/}
                {/*                    style={{*/}
                {/*                        fontSize: '18px',*/}
                {/*                    }}*/}
                {/*                />*/}
                {/*            )*/}
                {/*        }*/}
                {/*        className="h-8 w-8 p-0 text-slate-500 hover:text-blue-600"*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
        </>
    );
}
